<template>
  <v-container
    fill-height
    fluid
  >
    <v-data-table
      height="calc(100vh - 142px)"
      :headers="headers"
      :loading="loading"
      item-key="account_id"
      :items="items"
      :sort-by="['date']"
      :sort-desc="[true]"
      multi-sort
      class="col-12 v-data-table_disable-row_hover pb-0 kyc-data-table"
      :options.sync="options"
      :server-items-length="total"
      :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
      :items-per-page="25"
      fixed-header
    >

      <template v-slot:top>
        <v-row class="mx-0">
          <select-project
            v-model="project"
            class="col-1"
            style="min-width: 250px; max-width: 250px"
          ></select-project>
          <v-btn
            color="info"
            v-on:click="search"
            class="mt-3"
            :disabled="loading"
            :loading="loading"
          >
            Search
          </v-btn>
        </v-row>

      </template>

      <template v-slot:body="{ items }">
        <thead>
          <tr class="grey lighten-3 documents-filter-row">
            <td
              v-for="header in headers"
              :key="header.text"
              style="border: none"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                clearable
                persistent-hint
                single-line
                class="ma-0 pa-0"
                :items="filters[header.value].values"
                style="width: 100px"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
                style="width: 150px"
              />
              <withdraw-comments style="max-width: 250px" v-if="filters[header.value]?.type == 'comment'" v-model="filters[header.value].data" :commentsPreset="commentsPreset" :save-icon="false" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td :colspan="headers.length" class="px-1 py-3">

              <v-expansion-panels class="kyc-details" v-model="expandedIndex">
                <v-expansion-panel
                  v-for="(item, i) in items"
                  :key="i"
                >

                  <v-expansion-panel-header v-slot="{ open }">
                    <v-row no-gutters>

                      <div style="width: 230px; line-height: 24px">
                        {{ item.prefix + item.login }} #{{ item.account_id }}
                      </div>
                      <v-spacer />
                      <div v-if="!open" style="line-height: 24px;">
                        {{ item.data.comment }}
                      </div>
                      <v-spacer />
                      <div v-if="!open">
                        <v-row class="pr-5">
                          <v-spacer />
                          <v-checkbox
                            readonly
                            class="mt-0 pt-0 ml-3"
                            label="Verified"
                            v-model="item.kyc.verified"
                            hide-details
                          />
                          <v-checkbox
                            readonly
                            class="mt-0 pt-0 ml-3"
                            label="Automatic Verified"
                            v-model="item.kyc.primary_verification"
                            hide-details
                          />
                          <template
                            v-for="(val, key) in (item.kyc.details || {})"
                          >
                            <v-checkbox
                              readonly
                              class="mt-0 pt-0 ml-3"
                              :key="key"
                              :align-self="key"
                              :label="key"
                              v-model="item.kyc.details[key]"
                              hide-details
                            />
                          </template>
                        </v-row>
                      </div>
                    </v-row>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-divider />

                    <v-data-iterator
                      :loading="item.details.loading"
                      :items="item.details.summary"
                      hide-default-footer
                      fixed-header
                      class="comment-table document-table"
                    >
                      <template v-slot:loading>
                        <v-progress-linear
                          color="green"
                          indeterminate
                          height="2"
                        ></v-progress-linear>

                        <v-row>
                          <v-progress-circular
                            :size="100"
                            :width="7"
                            color="green"
                            indeterminate
                            class="mx-auto my-7"
                          >
                            Loading ...
                          </v-progress-circular>
                        </v-row>
                      </template>
                      <template v-slot:default="props">

                        <v-row justify="center">
                          <v-col
                            cols="12"
                            sm="6"
                            md="3"
                            lg="3"
                          >
                            <v-card>
                              <v-card-title class="subheading font-weight-bold px-3" style="font-size: 18px;">
                                <a :href="'/user-management/' + item.prefix + item.login " target="_blank">{{ item.prefix + item.login }}</a>
                                <v-spacer />
                                #{{ item.account_id }}
                              </v-card-title>

                              <v-divider />

                              <v-list dense class="rounded-top-0 documents-type-list">

                                <v-list-item>
                                  <v-list-item-content>
                                    <div class="d-flex pb-2 justify-space-around align-center">
                                      <v-switch
                                        label="Verified"
                                        hide-details
                                        @change="save(item, 'verified')"
                                        v-model="item.kyc.verified"
                                      />
                                      <v-switch
                                        label="Automatic Verified"
                                        hide-details
                                        @change="save(item, 'primary_verification')"
                                        v-model="item.kyc.primary_verification"
                                      />
                                    </div>
                                  </v-list-item-content>
                                </v-list-item>
                                <v-divider />
                                <v-list-item>
                                  <v-list-item-content class="pb-2" style="padding-top: 13px;">
                                    <withdraw-comments v-model="item.data.comment" :commentsPreset="commentsPreset" @updateTransaction="save(item, 'comment')" />
                                  </v-list-item-content>
                                </v-list-item>

                              </v-list>
                            </v-card>
                          </v-col>

                          <v-col
                            v-for="doc in props.items"
                            :key="doc.type"
                            cols="12"
                            sm="6"
                            :md="parseInt(12 / props.items.length) >= 2 ? parseInt(12 / props.items.length) : 4"
                            :lg="parseInt(12 / props.items.length) >= 2 ? parseInt(12 / props.items.length) : 3"
                            :style="{'min-width': '148px', 'max-width': props.items.length >= 4 ? '14%' : false}"
                          >
                            <v-card
                              :color="verificationState(doc)"
                            >
                              <v-card-title class="subheading font-weight-bold px-2">
                                {{ doc.type }}

                                <v-spacer />

                                <v-checkbox
                                  class="ma-0"
                                  @change="save(item, 'details.' + doc.type)"
                                  v-model="item.kyc.details[doc.type]"
                                  hide-details
                                  color="grey darken-4"
                                  style="width: 24px"
                                  :readonly="!$store.state.auth.checkAccess({key: 'kyc_verification', value: true})"
                                ></v-checkbox>
                              </v-card-title>

                              <v-divider></v-divider>

                              <v-list dense class="rounded-top-0 documents-type-list">

                                <v-list-item>
                                  <v-list-item-content>New:</v-list-item-content>
                                  <v-list-item-action class="align-end">
                                    {{ doc.new }}
                                  </v-list-item-action>
                                </v-list-item>

                                <v-list-item>
                                  <v-list-item-content>Accepted:</v-list-item-content>
                                  <v-list-item-action class="align-end">
                                    {{ doc.accept }}
                                  </v-list-item-action>
                                </v-list-item>

                                <v-list-item>
                                  <v-list-item-content>Declined:</v-list-item-content>
                                  <v-list-item-action class="align-end">
                                    {{ doc.decline }}
                                  </v-list-item-action>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-btn
                                      small
                                      outlined
                                      :text="item.details.type != doc.type"
                                      @click="toggleDocuments(item, doc.type)"
                                    >
                                      {{ item.details.type == doc.type ? 'Close' : 'Preview' }}
                                    </v-btn>
                                  </v-list-item-content>
                                </v-list-item>

                              </v-list>
                            </v-card>
                          </v-col>
                        </v-row>
                      </template>

                    </v-data-iterator>

                    <v-expand-transition>
                      <v-data-table
                        v-if="item.details.type"
                        :headers="subHeaders"
                        :loading="loading"
                        :items="get(item.details, [ 'items', item.details.type ], [])"
                        :items-per-page="-1"
                        class="col-12 pa-0"
                        fixed-header
                        hide-default-footer
                      >


                        <template v-slot:item.login="{ item }">
                          <a :href="'/user-management/' + item.data.prefix + item.data.login " target="_blank">{{ item.data.prefix + item.data.login }}</a>
                        </template>
                        <template v-slot:item.data.comment="{ item }">
                          <span class="ql-editor" style="padding: 0; margin: 0" v-html="$sanitize(item.data.comment)"></span>
                        </template>

                        <template v-slot:item.data.internal_comment="{ item }">
                          <span class="ql-editor" style="padding: 0; margin: 0" v-html="$sanitize(item.data.internal_comment)"></span>
                        </template>

                        <template v-slot:item.status="{ item }">
                          <v-chip
                            class="rounded-8 height-25"
                            :color="getColor(item.status)">{{ item.status }}
                          </v-chip>
                        </template>

                        <template v-slot:item.type="{ item }">
                          {{ item.type.replace(/[,]{1,}/g, ', ') }}
                        </template>

                        <template v-slot:item.date="{ item: documentItem }">
                          <div class="d-flex">
                            {{ documentItem.updated || documentItem.created }}
                            <v-tooltip
                              right
                              close-delay="1500"
                              v-if="documentItem.account_id !== item.account_id"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon color="light-green">
                                    mdi-account-alert
                                  </v-icon>
                                </v-btn>
                              </template>
                              <a class="white--text" :href="`/user-management/${documentItem.data.prefix}${documentItem.data.login}`" target="_blank">{{ `${documentItem.data.prefix}${documentItem.data.login}` }}</a>
                            </v-tooltip>
                          </div>
                        </template>

                        <template v-slot:item.action="{ item }">
                          <span style="white-space: nowrap">
                            <v-btn
                              :disabled="!item.data.path"
                              color="success"
                              outlined
                              small
                              :loading="loading"
                              class="mr-2"
                              @click="openImage(item)"
                            >
                              View
                            </v-btn>

                            <v-icon
                              color="green"
                              @click="documentVerification(item,true)"
                            >
                              mdi-check-circle
                            </v-icon>
                            <v-icon
                              color="red"
                              @click="documentVerification(item,false)"
                            >
                              mdi-close-circle
                            </v-icon>
                            <v-icon
                              class="ml-2"
                              @click="viewDocument(item)"
                            >
                              mdi-cog
                            </v-icon>
                          </span>
                        </template>

                        <template v-slot:no-data>
                          <v-btn @click="expande(item)" icon fab class="mt-4">
                            <v-icon x-large>refresh</v-icon>
                          </v-btn>
                        </template>

                      </v-data-table>
                    </v-expand-transition>


                    <v-divider class="mb-5" />

                    <v-btn
                      :text="!item.transactions.show"
                      outlined
                      @click="item.transactions.show = !item.transactions.show"
                      small
                      class="col-12"
                    >Recent Transactions
                    </v-btn>
                    <v-expand-transition>
                      <v-data-table
                        v-show="item.transactions.show"
                        :headers="transactionHeaders"
                        :items="item.transactions.items"
                        :loading="item.transactions.loading"
                        :options.sync="item.transactions.options"
                        @update:options="loadTransactions(item)"
                        :server-items-length="item.transactions.total"
                        :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
                        :items-per-page="15"
                        sort-by="created"
                        sort-desc
                        height="330"
                        fixed-header
                        class="col-12 pa-0 kyc-recent-transactions"
                      >
                        <template v-slot:item.comment="{ item }">
                          <div style="max-width: 400px;">
                            {{ item.comment }}
                          </div>
                        </template>
                      </v-data-table>
                    </v-expand-transition>

                  </v-expansion-panel-content>

                </v-expansion-panel>

              </v-expansion-panels>

            </td>
          </tr>
        </tbody>
      </template>

      <template v-slot:no-data>
        <v-btn @click="search" icon fab class="mt-4">
          <v-icon x-large>refresh</v-icon>
        </v-btn>
      </template>

      <template v-slot:footer.page-text="{ pageStart , pageStop , itemsLength }">
        {{ pageStart }} - {{ pageStop }} of {{ itemsLength }}
        <v-btn @click="search" icon style="margin-right: -35px;">
          <v-icon>refresh</v-icon>
        </v-btn>
      </template>
    </v-data-table>


    <update-form
      v-model="dialog"
      :item="cloneDeep(item)"
      @save="documentUpdate"
      :openImage="openImage"
      :loading="loading"
      :commentsPreset="$options.commentsPreset"
      :internalPreset="$options.internalPreset"
    />
  </v-container>
</template>

<style>
  .comment-table td {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .comment-table td > span > p {
    padding: 0;
    margin: 0;
  }

  .documents-type-list .v-list-item {
    min-height: 26px;
  }

  .documents-type-list .v-list-item .v-list-item__content,
  .documents-type-list .v-list-item .v-list-item__action {
    padding: 0px;
    margin: 0px;
  }

  .documents-filter-row td,
  .documents-filter-row th {
    height: 34px !important;
  }

  .documents-filter-row .v-input {
    margin-top: 0;
    padding-top: 0;
    font-size: 14px;
  }

  .documents-type-list .align-end {
    justify-content: flex-end;
  }

  .kyc-details .v-expansion-panel-content__wrap {
    padding-left: 16px;
    padding-right: 16px;
  }

  .kyc-recent-transactions {
    margin-bottom: -10px;
  }

  .kyc-data-table .v-data-footer__select,
  .kyc-recent-transactions .v-data-footer__select {
    height: 45px;
  }

</style>

<script>

  import UpdateForm from '@/components/documents/UpdateForm'

  import { API } from '@/utils/api'
  import { get, set, map, cloneDeep, keys, isBoolean, isNumber } from 'lodash'
  import WithdrawComments from '@/components/helper/WithdrawComments.vue'

  import { internalPreset, commentsPreset } from '@/utils/mock'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  export default {
    internalPreset,
    commentsPreset,
    components: { SelectProject, UpdateForm, WithdrawComments },

    data: () => ({
      commentsPreset: [
        'Waiting for docs!!!',
        'Hold',
        'Provider`s check',
      ],
      expandedIndex: null,
      dialog: false,
      expanded: [],
      item: false,
      subItems: [],
      options: {},
      total: 0,
      project: false,
      loading: false,
      chipColor: {
        accept: 'green lighten-3',
        decline: 'red lighten-3',
      },
      items: [],
      headers: [
        { text: 'ID', value: 'account_id', sortable: false },
        { text: 'Comment', value: 'data.comment', sortable: false },
        // { text: 'Login', value: 'login', sortable: false },
        { text: 'Verified', value: 'kyc.verified', sortable: false },
        { text: 'Automatic Verified', value: 'kyc.primary_verification', sortable: false },
        { text: 'New requests', value: 'new_requests', sortable: false },
        { text: '', value: 'data-table-expand', 'class': 'nowrap' },
      ],
      subHeaders: [
        { text: 'Date', value: 'date' },
        // { text: 'Login', value: 'login', sortable: false },
        // { text: 'Type', value: 'type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Comment', align: 'left', sortable: false, value: 'data.comment' },
        { text: 'Int Comment', align: 'left', sortable: false, value: 'data.internal_comment' },
        { text: '', value: 'action', sortable: false, align: 'right' },
      ],

      transactionHeaders: [
        { text: 'Created', value: 'created' },
        { text: 'Finished', value: 'completed' },
        { text: 'ID', value: 'account_transaction_id', sortable: true },
        { text: 'Account', value: 'account', sortable: true },
        { text: 'Description', align: 'left', sortable: false, value: 'comment' },
        { text: 'Debit/Credit', value: 'amount', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Paymethod', value: 'paymethod', sortable: false },
        { text: 'Paysystem', value: 'paysystem', sortable: false },
      ],
      filters: {
        account_id: { data: [], type: 'text', values: [] },
        // login: { data: [], type: 'text', values: [] },
        'kyc.verified': { data: [], type: 'select', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
        'kyc.primary_verification': { data: [], type: 'select', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
        'new_requests': { data: true, type: 'select', values: [ { text: 'Yes', value: true }, { text: 'No', value: false } ] },
        'data.comment': { data: '', type: 'comment', values: [] },
      },
    }),

    watch: {
      expandedIndex: function () {
        if (this.expandedIndex == undefined) {
          return
        }

        this.expande(this.items[this.expandedIndex])
      },
      options: {
        handler () {
          this.search()
        },
      }
    },

    methods: {
      keys,
      get,
      cloneDeep,

      viewDocument: function (item) {
        this.item = item
        this.dialog = true
      },

      toggleDocuments: function (item, type) {
        if (item.details.type == type) {
          item.details.type = null
        } else {
          item.details.type = type
        }
      },

      verificationState: function (item) {

        if (item.new == 0 && item.on_review == 0 && item.accept == 0 && item.decline > 0) {
          return 'red lighten-3'
        }
        if (((item.new >= 0 && item.decline > 0) || (item.new > 0 && item.decline >= 0)) && item.on_review >= 0 && item.accept > 0) {
          return 'orange lighten-3'
        }
        if (item.new == 0 && item.on_review == 0 && item.accept > 0 && item.decline == 0) {
          return 'green lighten-3'
        }

        return
      },

      getColor: function (status) {
        return this.chipColor[status]
      },

      documentUpdate: function (item) {

        if (!item.type) return

        this.loading = true
        API.call('/$v/documents/update.json', {
          document_id: item.document_id,
          account_id: item.account_id,
          status: item.status,
          comment: item.data.comment,
          internal_comment: item.data.internal_comment,
          type: item.type
        }, null, this.project).then(resp => {
          this.dialog = false
        }).finally(r => {
          this.loading = false
          this.expande(this.items[this.expandedIndex], false)
        })
      },

      save: function (item, field) {

        let params = { account_id: item.account_id }

        set(params, field, get({ ...item.kyc, ...item.data }, field))

        this.loading = true
        API.call('/$v/account/kyc/update.json', params, null, this.project).then(resp => {
        }).finally(r => {
          this.loading = false
        })
      },

      documentVerification: async function (item, status) {
        let message = status ? 'Accept documents' : 'Decline documents'
        if (!await this.$root.$confirm('Confirm', message)) return

        status = status ? 'accept' : 'decline'

        item.status = status

        return this.documentUpdate(item)
      },

      async openImage (item, open = true) {
        this.loading = true
        return API.call('/$v/documents/image.json', {
          document_id: item.document_id,
          account_id: item.account_id,
        }, null, this.project).then(resp => resp.data).then(r => {

          if (!open) {
            return r.img
          }

          if (r.img.match(/^data/)) {

            if (window.URL) {

              function base64ToArrayBuffer (_base64Str) {
                let binaryString = window.atob(_base64Str)
                let binaryLen = binaryString.length
                let bytes = new Uint8Array(binaryLen)
                for (let i = 0; i < binaryLen; i++) {
                  let ascii = binaryString.charCodeAt(i)
                  bytes[i] = ascii
                }
                return bytes
              }

              let data = r.img.match(/data:(.*)?;base64,(.*)?/)

              let byte = base64ToArrayBuffer(data[2])

              let blob = new Blob([ byte ], { type: data[1] })

              window.open(window.URL.createObjectURL(blob), '_blank')

            } else {

              let w = window.open('')
              if (r.img.match(/^data:application\/pdf/)) {
                w.document.write('<html><body style="margin:0!important"><embed width="100%" height="100%" src="' + r.img + '" /></body></html>')
              } else {
                w.document.write('<html><body style="margin:0!important"><embed style="max-width: 100%; max-height: 100%;" src="' + r.img + '" /></body></html>')
              }
              w.stop()
            }

          } else {
            window.open(r.img, '_blank')
          }
        }).finally((r) => {
          this.loading = false
          return r
        })
      },

      search: function () {
        this.loading = true
        this.expandedIndex = null

        let params = {
          ...this.options
        }

        if (this.filters.account_id.data.length > 0) {
          params.account_id = parseInt(this.filters.account_id.data)
        }

        // if (this.filters.login.data.length > 0) {
        // params.login = this.filters.login.data
        // }

        if (isBoolean(this.filters.new_requests.data)) {
          params.new_requests = this.filters.new_requests.data
        }

        if (_.isBoolean(this.filters['kyc.verified'].data)) {
          params.verified = this.filters['kyc.verified'].data
        }

        if (_.isBoolean(this.filters['kyc.primary_verification'].data)) {
          params.primary_verification = this.filters['kyc.primary_verification'].data
        }
        if (this.filters['data.comment'].data) {
          params.comment = this.filters['data.comment'].data
        }

        API.call('/$v/kyc/list.json', params, null, this.project).then(resp => {

          this.items = get(resp, 'data', [])
          this.total = resp.total

          return resp.data
        }).catch(e => {
        }).finally(() => {
          this.loading = false
        })
      },

      loadTransactions: function (item) {
        item.transactions.loading = true
        return API.call('/$v/account/finance/list.json', {
          login: item.prefix + item.login,
          account_id: item.account_id,
          options: item.transactions.options,
          filters: {
            type: { data: [ 'deposit', 'withdraw' ] },
            status: { data: [ 'completed', 'pending' ] },
          }
        }, { login: item.prefix + item.login }).then(resp => {

          item.transactions.items = resp.data
          item.transactions.total = resp.total

          return resp.data
        }).finally(() => {
          item.transactions.loading = false
        })
      },

      expande: function (item, reopen = true) {

        let params = {
          login: item.prefix + item.login,
          account_id: item.account_id
        }

        if (reopen) {
          item.transactions.show = false
          item.details = {
            type: null,
            loading: true,
            summary: [],
            items: {},
          }
        }

        API.call('/$v/account/kyc/get.json', params, params).then(resp => resp.data).then(r => {
          item.details.summary = r.summary
          item.details.items = r.documents
        }).catch(e => {
        }).finally(() => {
          item.details.loading = false
        })

      },

    },
  }
</script>
